// extracted by mini-css-extract-plugin
export var label = "_47-1";
export var reminder = "_47-0";